import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import GeoAnalyzerTab from './geo/GeoAnalyzerTab';
import CompetitorTab from './geo/CompetitorTab';

const GeoToolsPage = () => (
  <div className="space-y-8">
    <div>
      <h1 className="text-3xl font-fraunces font-bold" style={{ color: 'var(--blue)' }}>GEO Tools</h1>
      <p className="text-muted-foreground mt-1">Generative Engine Optimization &amp; Competitive Intelligence</p>
    </div>

    <Tabs defaultValue="geo" className="w-full">
      <TabsList>
        <TabsTrigger value="geo">GEO Analyzer</TabsTrigger>
        <TabsTrigger value="competitor">Competitor Analysis</TabsTrigger>
      </TabsList>
      <TabsContent value="geo"><GeoAnalyzerTab /></TabsContent>
      <TabsContent value="competitor"><CompetitorTab /></TabsContent>
    </Tabs>
  </div>
);

export default GeoToolsPage;
